<template>
    <div data-app="true" class="component-wrap">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column :class="{'pa-0 py-4': $vuetify.breakpoint.xs,'pa-4' : $vuetify.breakpoint.smAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'mx-3': $vuetify.breakpoint.xs}">
                    <v-icon slot="divider">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1">keyboard_arrow_left</v-icon> {{$t("Главная")}}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <div>
                    <v-layout row wrap align-center
                              mb-4 :class="{'px-3': $vuetify.breakpoint.xs}"
                    >
                        <v-flex lg12>
                            <h1 class="section-title-main my-3 mr-4 font-weight-regular">{{$t("История начисления баллов")}}</h1>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap align-center justify-space-between
                              :class="{'px-3': $vuetify.breakpoint.xs}"
                    >
                        <v-flex>
                            <v-tabs
                                v-model="tabs"
                                slot="extension"
                                color="white"
                                slider-color="red"
                                class="pr-4 tabs__bottom-border"
                            >
                                <v-tab>
                                    <v-layout row wrap align-center>
                                        <v-flex>{{$t("Все")}}</v-flex>
                                    </v-layout>
                                </v-tab>
                                <v-tab width="260px">
                                    <v-layout row wrap align-center>
                                        <v-flex>{{$t("Начисления баллов")}}</v-flex>
                                    </v-layout>
                                </v-tab>
                                <v-tab>
                                    <v-layout row wrap align-center>
                                        <v-flex>{{$t("Списания баллов")}}</v-flex>
                                    </v-layout>
                                </v-tab>
                            </v-tabs>
                        </v-flex>
                        <v-flex xl4 lg3 md4
                                xs12 :class="{'mb-4': $vuetify.breakpoint.smAndDown, 'pr-4': $vuetify.breakpoint.mdAndUp}"
                        >
                            <v-select
                                :items="[$t('Сначала новые'),$t('Сначала старые')]"
                                solo
                                append-icon=""
                                :label="$t('Сначала новые')"
                                class="input"
                                @change="sorting_by_date($event)"
                            >
                              <template #append>
                                <v-icon aria-hidden="true" translate="no">
                                  expand_more
                                </v-icon>
                              </template>
                            </v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout my-5 column>
                        <div v-for="(item, i) in paginated" :key="i">
                            <PointsBlock class="mb-4" :tab="tab" :content="item"
                                         :class="{'background-light': !(i%2)}"
                            />
                        </div>
                        <div v-if="paginated.length == 0">{{$t("Ничего не найдено")}}</div>
                    </v-layout>
                    <v-layout v-if="filtered_by_type && filtered_by_type.length > 10" mb-5 justify-end
                              align-center
                              wrap :class="{'px-3': $vuetify.breakpoint.xs}"
                    >
                        <v-flex md5 sm7 xs12
                                mb-4
                        >
                            <div class="text-xs-center">
                                <v-pagination
                                    v-model="page"
                                    :length="Math.ceil(filtered_by_type.length / selected_number)"
                                    :total-visible="$vuetify.breakpoint.xs ? 4 : 6"
                                    prev-icon="arrow_back_ios"
                                    next-icon="arrow_forward_ios"
                                />
                            </div>
                        </v-flex>
                        <v-flex md4 sm6 mb-4>
                            <v-select
                                :items="$vuetify.breakpoint.mdAndUp ? [$t('Показывать по 10'),$t('Показывать по 25'),$t('Показывать по 50'),$t('Показывать по 100')]
                                : [$t('Показывать по 10'),$t('Показывать по 25'),$t('Показывать по 50')]"
                                solo
                                append-icon=""
                                :label="$t('Показывать по 10')"
                                class="input"
                                @change="show_number($event)"
                            >
                              <template #append>
                                <v-icon aria-hidden="true" translate="no">
                                  expand_more
                                </v-icon>
                              </template>
                            </v-select>
                        </v-flex>
                    </v-layout>
                </div>
            </v-layout>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import PointsBlock from '@/components/view_blocks/Points_history/Points_history_block';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    PointsBlock,
  },
  computed: {
    ...mapGetters('points_history/breadcrumbs', [
      'breadcrumbs',
    ]),
    ...mapGetters('points_history', [
      'history_items',
      'filtered_by_type',
      'selected_number',
      'tab',
      'paginated',
      'selected_page',
    ]),
    page: {
      get() {
        return this.selected_page;
      },
      set($event) {
        return this.SET_SELECTED_PAGE($event);
      },
    },
    tabs: {
      get() {
        return this.tab;
      },
      set($event) {
        return this.SET_TAB($event);
      },
    },
  },
  mounted() {
    this.get_user_points();
  },
  methods: {
    ...mapMutations('points_history', [
      'SET_SELECTED_PAGE',
      'SHOW_NUMBER',
      'CLEAR_PAGES',
      'SORT_BY_DATE',
      'SET_TAB',
    ]),
    ...mapActions('points_history', [
      'show_number',
      'sorting_by_date',
      'set_tab',
      'get_user_points',
    ]),
  },
};
</script>
